

import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';


export class ProjectsReuseStrategy implements RouteReuseStrategy {

    public shouldDetach(route: ActivatedRouteSnapshot): boolean { return false; };
    public store = (route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void => {};
    public shouldAttach(route: ActivatedRouteSnapshot): boolean { return false; };
    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle { return {}; };
    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {


        // console.log("ProjectsReuseStrategy shouldReuseRoute", "future", future, "current", curr);

        return (future.routeConfig === curr.routeConfig && future.params['project'] === curr.params['project']) || future.data['reuse'];
        // return false;

        // return future.
    };
}
